export default __webpack_public_path__ + "static/media/1960.cb765216.png";